import { render, staticRenderFns } from "./LawServiceLogListForm.vue?vue&type=template&id=b192ef74&"
import script from "./LawServiceLogListForm.vue?vue&type=script&lang=js&"
export * from "./LawServiceLogListForm.vue?vue&type=script&lang=js&"
import style0 from "./LawServiceLogListForm.vue?vue&type=style&index=0&id=b192ef74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports